import { render, staticRenderFns } from "./BusinessProcessView.vue?vue&type=template&id=050cef6f&"
import script from "./BusinessProcessView.vue?vue&type=script&lang=js&"
export * from "./BusinessProcessView.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProcessView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports